import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaUserPlus,
    FaUsers,
    FaMicrochip,
    FaSignOutAlt,
} from 'react-icons/fa';

import { CircuitBackgroundLayer } from '../../components/CircuitBackground/AnimatedCircuitChipBackground';
import styles from '../Monitor/Monitor.module.css';

const AdminDashboard = ({ onLogout }) => {
    const navigate = useNavigate();

    const user = (() => {
        try {
            return JSON.parse(localStorage.getItem('user') || '{}');
        } catch {
            return {};
        }
    })();

    return (
        <div className={styles.container}>
            <CircuitBackgroundLayer />
            <div className={styles.overlay}></div>

            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.deviceTitle}>
                        <span style={{ fontSize: '2rem' }}>🛠️</span>
                        <div>
                            <div style={{ fontWeight: 'bold' }}>داشبورد مدیریت</div>
                            <span style={{ fontSize: '12px', color: '#ccc' }}>
                                {user?.name ? `${user.name} ${user.family || ''}` : 'اپراتور مدیریت'} | نقش: admin
                            </span>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <button
        onClick={onLogout}
        className={styles.logoutBtn}
        type="button"
    >
        <FaSignOutAlt /> خروج
    </button>
</div>
                </div>

                <div style={adminGridStyle}>
                    <AdminCard
                        icon={<FaUserPlus size={36} color="#2ecc71" />}
                        title="تعریف کاربر و دستگاه"
                        description="ایجاد مشتری جدید، تولید رمز اولیه و اتصال دستگاه به کاربر"
                        onClick={() => navigate('/admin/create-user-device')}
                    />

                  <AdminCard
                      icon={<FaUsers size={36} color="#3498db" />}
                      title="مدیریت کاربران"
                      description="لیست کاربران، وضعیت، ریست رمز و مشاهده دستگاه‌ها"
                      onClick={() => navigate('/admin/users')}
                 />

                    <AdminCard
                            icon={<FaMicrochip size={36} color="#f1c40f" />}
                            title="مدیریت دستگاه‌ها"
                            description="لیست دستگاه‌ها، مالک، تاریخ شروع و پایان سرویس"
                            onClick={() => navigate('/admin/devices')}
                    />
                </div>
            </div>
        </div>
    );
};

const AdminCard = ({ icon, title, description, badge, onClick }) => {
    return (
        <div style={adminCardStyle} onClick={onClick}>
            {badge && <div style={badgeStyle}>{badge}</div>}

            <div style={iconBoxStyle}>
                {icon}
            </div>

            <h3 style={cardTitleStyle}>{title}</h3>
            <p style={cardDescStyle}>{description}</p>
        </div>
    );
};

const adminGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    width: '100%',
    marginTop: '30px',
    direction: 'rtl'
};

const adminCardStyle = {
    position: 'relative',
    background: 'rgba(31, 45, 58, 0.92)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '18px',
    padding: '24px',
    minHeight: '190px',
    color: '#fff',
    cursor: 'pointer',
    boxShadow: '0 10px 35px rgba(0,0,0,0.25)',
    transition: 'transform 0.2s ease, border-color 0.2s ease',
    overflow: 'hidden'
};

const iconBoxStyle = {
    width: '62px',
    height: '62px',
    borderRadius: '16px',
    background: 'rgba(255,255,255,0.06)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '18px'
};

const cardTitleStyle = {
    margin: '0 0 10px',
    fontSize: '18px',
    color: '#f8fafc'
};

const cardDescStyle = {
    margin: 0,
    fontSize: '13px',
    lineHeight: '1.9',
    color: '#bdc3c7'
};

const badgeStyle = {
    position: 'absolute',
    top: '14px',
    left: '14px',
    background: 'rgba(241, 196, 15, 0.16)',
    border: '1px solid rgba(241, 196, 15, 0.35)',
    color: '#f1c40f',
    fontSize: '11px',
    borderRadius: '999px',
    padding: '4px 10px'
};

export default AdminDashboard;